import { render, staticRenderFns } from "./CMMenu.vue?vue&type=template&id=08e5a348&scoped=true&lang=pug&"
import script from "./CMMenu.vue?vue&type=script&lang=js&"
export * from "./CMMenu.vue?vue&type=script&lang=js&"
import style0 from "./CMMenu.vue?vue&type=style&index=0&id=08e5a348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e5a348",
  null
  
)

export default component.exports